import {styled} from '@linaria/react';
import React from 'react';
import {Z_INDEXES} from '../../../constants/layers';
import {PriceBox, PriceBoxProps} from '../../molecules/PriceBox/PriceBox';
import {PriceBoxSaleCountdown} from '../PriceBoxSaleCountdown/PriceBoxSaleCountdown';

export const PriceBoxWithCountdown: React.FC<PriceBoxProps> = props => {
  return (
    <PriceBox CountdownComponent={StyledPriceBoxSaleCountdown} {...props} />
  );
};

const StyledPriceBoxSaleCountdown = styled(PriceBoxSaleCountdown)`
  z-index: ${Z_INDEXES.ADP_COUNTDOWN};
  position: absolute;
  bottom: calc(100% + 4px);
`;
